import React, { useState } from 'react';
import { createMatch } from '../../services/leagueService';
import { IconCircleX } from '@tabler/icons-react';

const CreateMatchModal = ({ leagueId, members, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    participant1Id: '',
    participant2Id: '',
    scheduledTime: '',
    location: ''
  });
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.participant1Id || !formData.participant2Id) {
      setError('Please select both participants');
      return;
    }

    if (formData.participant1Id === formData.participant2Id) {
      setError('Participants must be different');
      return;
    }

    setCreating(true);
    setError('');

    try {
      const participant1 = members.find(m => m.userId === formData.participant1Id);
      const participant2 = members.find(m => m.userId === formData.participant2Id);

      await createMatch(leagueId, {
        participant1Id: formData.participant1Id,
        participant1Name: `${participant1.firstName} ${participant1.lastName}`,
        participant2Id: formData.participant2Id,
        participant2Name: `${participant2.firstName} ${participant2.lastName}`,
        scheduledTime: formData.scheduledTime || null,
        location: formData.location || null,
        status: 'scheduled',
        participant1Score: 0,
        participant2Score: 0,
        winnerId: null
      });

      if (onSuccess) {
        onSuccess();
      }
      onClose();
    } catch (err) {
      console.error('Error creating match:', err);
      setError('Failed to create match. Please try again.');
    } finally {
      setCreating(false);
    }
  };

  const availableMembers = members.filter(m => m.status === 'active');

  return (
    <section className="ls-create-match-modal">
      <section className="ls-modal-content">
        <header className="ls-modal-header">
          <h2>Schedule Match</h2>
          <button onClick={onClose} className="ls-close-btn" aria-label="Close modal">
            <IconCircleX width={24} height={24} />
          </button>
        </header>

        <form onSubmit={handleSubmit} className="ls-create-match-form">
          <div className="ls-form-group">
            <label htmlFor="participant1Id">Participant 1 *</label>
            <select
              id="participant1Id"
              name="participant1Id"
              value={formData.participant1Id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select participant</option>
              {availableMembers.map(member => (
                <option key={member.userId} value={member.userId}>
                  {member.firstName} {member.lastName}
                </option>
              ))}
            </select>
          </div>

          <div className="ls-vs-divider">
            <span>VS</span>
          </div>

          <div className="ls-form-group">
            <label htmlFor="participant2Id">Participant 2 *</label>
            <select
              id="participant2Id"
              name="participant2Id"
              value={formData.participant2Id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select participant</option>
              {availableMembers.map(member => (
                <option key={member.userId} value={member.userId}>
                  {member.firstName} {member.lastName}
                </option>
              ))}
            </select>
          </div>

          <div className="ls-form-group">
            <label htmlFor="scheduledTime">Date & Time</label>
            <input
              type="datetime-local"
              id="scheduledTime"
              name="scheduledTime"
              value={formData.scheduledTime}
              onChange={handleInputChange}
            />
          </div>

          <div className="ls-form-group">
            <label htmlFor="location">Location</label>
            <input
              type="text"
              id="location"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              placeholder="e.g., Court 3"
            />
          </div>

          {error && (
            <section className="ls-error-message" role="alert">{error}</section>
          )}

          <footer className="ls-modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="ls-btn-secondary"
              disabled={creating}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="ls-btn-primary"
              disabled={creating}
            >
              {creating ? 'Creating...' : 'Schedule Match'}
            </button>
          </footer>
        </form>
      </section>
    </section>
  );
};

export default CreateMatchModal;
